module.exports = __webpack_public_path__ + "static/media/zodiac_border.fc87cdb0.png";